export interface UmpireStatisticValues {
  away_goals: string | undefined;

  assists: string | undefined;

  ball_blocks: string | undefined;

  ball_possession_percent: string | undefined;

  challenges: string | undefined;

  challenges_lost: string | undefined;

  challenges_on_air: string | undefined;

  challenges_on_air_won: string | undefined;

  challenges_on_air_lost: string | undefined;

  challenges_on_ground: string | undefined;

  challenges_on_ground_won: string | undefined;

  challenges_on_ground_lost: string | undefined;

  challenges_won: string | undefined;

  challenges_won_percent: string | undefined;

  crosses: string | undefined;

  crosses_accurate: string | undefined;

  crosses_accurate_percent: string | undefined;

  crosses_avg: string | undefined;

  distance: string | undefined;

  distance_avg: string | undefined;

  distance_total: string | undefined;

  dribbles: string | undefined;

  dribbles_avg: string | undefined;

  dribbles_successful: string | undefined;

  dribbles_successful_percent: string | undefined;

  dribbles_unsuccessful: string | undefined;

  expected_goals: string | undefined;

  expected_goals_avg: string | undefined;

  expected_goals_conceded: string | undefined;

  expected_goals_conceded_avg: string | undefined;

  fantasy_assists: string | undefined;

  fouls: string | undefined;

  fouled: string | undefined;

  gk_clean_sheets: string | undefined;

  gk_clean_sheets_avg: string | undefined;

  gk_expected_goals_conceded: string | undefined;

  gk_expected_goals_conceded_avg: string | undefined;

  gk_goals_conceded: string | undefined;

  gk_goals_conceded_avg: string | undefined;

  gk_penalties: string | undefined;

  gk_penalties_total: string | undefined;

  gk_penalties_saved: string | undefined;

  gk_shots_taken_percent: string | undefined;

  gk_shots_saved_percent: string | undefined;

  gk_shots_saved: string | undefined;

  goal_assists: string | undefined;

  goal_conversion: string | undefined;

  goals: string | undefined;

  goals_conceded: string | undefined;

  goals_from_inside_penalties_area: string | undefined;

  goals_from_outside_penalties_area: string | undefined;

  goals_scored: string | undefined;

  headed_goals: string | undefined;

  home_goals: string | undefined;

  instat_index: string | undefined;

  key_passes: string | undefined;

  key_passes_accurate: string | undefined;

  key_passes_accurate_percent: string | undefined;

  key_passes_percent: string | undefined;

  left_foot_goals: string | undefined;

  matches_played: string | undefined;

  matches_played_in_first_eleven: string | undefined;

  minutes_between_goals: string | undefined;

  minutes_played: string | undefined;

  passes: string | undefined;

  passes_accurate: string | undefined;

  passes_accurate_percent: string | undefined;

  passes_inaccurate: string | undefined;

  passes_forward: string | undefined;

  penalty_goals_total: string | undefined;

  penalty_goals_unsuccessful: string | undefined;

  penalty_goals_successful: string | undefined;

  red_cards: string | undefined;

  right_foot_goals: string | undefined;

  sprints: string | undefined;

  sprints_avg: string | undefined;

  sprints_total: string | undefined;

  shots: string | undefined;

  shots_avg: string | undefined;

  shots_on_target_avg: string | undefined;

  shots_on_target: string | undefined;

  shots_on_target_percent: string | undefined;

  shots_off_target: string | undefined;

  tackles: string | undefined;

  tackles_avg: string | undefined;

  tackles_successful: string | undefined;

  tackles_successful_avg: string | undefined;

  tackles_won_percent: string | undefined;

  tackles_unsuccessful: string | undefined;

  top_speed: string | undefined;

  top_speed_max: string | undefined;

  yellow_cards: string | undefined;
}
